module.exports = __webpack_public_path__ + "da451eb63931ffd35827a5e3337f3229.svg";